import React, { useContext, useEffect, useState } from 'react';
import ReportButton from './atoms/ReportButton';
import ReportingModal from './organisms/ReportingModal';
import EnvironmentContext from '@/client/contexts/EnvironmentContext';
import { FaqReportingContext } from './context/FaqReportingContext';
import isSsr from '@/client/utils/isSsr';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let Modal: any;

const FaqReportingContainer: React.FC = () => {
  const {
    userDetails: { isLoggedIn },
  } = useContext(EnvironmentContext);
  const { modalOpen, setModalOpen } = useContext(FaqReportingContext);
  const [isModalLoaded, setIsModalLoaded] = useState<boolean>(false);

  const loadModalComponent = async () => {
    Modal = (await import(/* webpackChunkName: "FaqReportingModal" */ './organisms/ReportingModal.tsx')).default;
    setIsModalLoaded(true);
  };

  useEffect(() => {
    if (isSsr()) return;
    if (window?.location?.hash === '#report-faq') {
      const url = window.location.href.replace('#report-faq', '');
      window.history.replaceState(null, '', url);

      if (modalOpen || !isLoggedIn) return;

      setModalOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (modalOpen && !isModalLoaded) {
      loadModalComponent();
    }
  }, [modalOpen, isModalLoaded]);

  return (
    <>
      <ReportButton />
      {isModalLoaded && modalOpen && isLoggedIn && <ReportingModal />}
    </>
  );
};

export default FaqReportingContainer;
